import React from "react";
import {withNamespaces} from "react-i18next";

import {gettingStartedSteps, gettingStartedSupport, gettingStartedTrial} from "../../content/getting-started";
import LandingArrowIcon from "../../ui/LandingArrowIcon";
import LandingCheckIcon from "../../ui/LandingCheckIcon";
import "./style.less";

function SupportIcon() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 12V10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V12"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
            />

            <path
                d="M5 11.5H6.5C7.05228 11.5 7.5 11.9477 7.5 12.5V16.5C7.5 17.0523 7.05228 17.5 6.5 17.5H5C4.44772 17.5 4 17.0523 4 16.5V12.5C4 11.9477 4.44772 11.5 5 11.5Z"
                stroke="currentColor"
                strokeWidth="1.7"
            />

            <path
                d="M17.5 11.5H19C19.5523 11.5 20 11.9477 20 12.5V16.5C20 17.0523 19.5523 17.5 19 17.5H17.5C16.9477 17.5 16.5 17.0523 16.5 16.5V12.5C16.5 11.9477 16.9477 11.5 17.5 11.5Z"
                stroke="currentColor"
                strokeWidth="1.7"
            />

            <path
                d="M19 17.5C19 19.433 17.433 21 15.5 21H13.5"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
            />
        </svg>
    );
}

function GettingStartedSection({t}) {
    return (
        <section
            className="getting-started landing-section landing-section--middle"
            id="start"
        >
            <div className="getting-started__decoration"/>

            <div className="container public-site-shell">
                <div className="getting-started__heading landing-section-heading">
                    <div>
                        <span className="getting-started__eyebrow landing-section-heading__eyebrow">
                            {t("main.landing.gettingStarted.eyebrow")}
                        </span>

                        <h2 className="getting-started__title landing-section-heading__title">
                            {t("main.landing.gettingStarted.title")}
                        </h2>
                    </div>

                    <p className="getting-started__intro landing-section-heading__intro">
                        {t("main.landing.gettingStarted.intro")}
                    </p>
                </div>

                <div className="getting-started__panel">
                    <div className="getting-started__main">
                        <div className="getting-started__steps">
                            {gettingStartedSteps.map((step, index) => (
                                <article
                                    className="getting-step"
                                    key={step.number}
                                >
                                    <div className="getting-step__top">
                                        <span className="getting-step__number">
                                            {step.number}
                                        </span>

                                        {index <
                                            gettingStartedSteps.length - 1 && (
                                                <span className="getting-step__line"/>
                                            )}
                                    </div>

                                    <h3>{t(step.titleKey)}</h3>
                                    <p>{t(step.descriptionKey)}</p>

                                    <span className="getting-step__complete">
                                        <LandingCheckIcon/>
                                    </span>
                                </article>
                            ))}
                        </div>

                        <div className="getting-started__support">
                            <span className="getting-started__support-icon">
                                <SupportIcon/>
                            </span>

                            <span className="getting-started__support-content">
                                <strong>
                                    {t(gettingStartedSupport.titleKey)}
                                </strong>

                                <span>
                                    {t(gettingStartedSupport.descriptionKey)}
                                </span>
                            </span>

                            <span className="getting-started__contacts">
                                <a href={gettingStartedSupport.phone.href}>
                                    {gettingStartedSupport.phone.label}
                                </a>

                                <a href={gettingStartedSupport.email.href}>
                                    {gettingStartedSupport.email.label}
                                </a>
                            </span>
                        </div>
                    </div>

                    <article className="getting-started__cta">
                        <div className="getting-started__cta-decoration"/>

                        <span className="getting-started__cta-badge">
                            {t(gettingStartedTrial.badgeKey)}
                        </span>

                        <div className="getting-started__cta-content">
                            <h3>{t(gettingStartedTrial.titleKey)}</h3>

                            <p>{t(gettingStartedTrial.descriptionKey)}</p>
                        </div>

                        <a
                            className="getting-started__cta-button"
                            href={gettingStartedTrial.href}
                        >
                            {t(gettingStartedTrial.actionKey)}
                            <LandingArrowIcon/>
                        </a>
                    </article>
                </div>
            </div>
        </section>
    );
}

export default withNamespaces("translation")(GettingStartedSection);
